import DocumentDownloadIcon from 'src/assets/images/icons/document-download.svg';
import ChevronDownIcon from 'src/assets/images/icons/chevron-down.svg';

interface DownloadButtonProps {
  onClickMoreAction: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isOpen?: boolean;
}

export const DownloadButton = ({ onClickMoreAction, isOpen = false }: DownloadButtonProps) => (
  <button
    aria-label='Download'
    type='button'
    className='flex items-center justify-center gap-8 px-12 py-10 rounded-lg border border-[#DFDFDF] bg-white transition-all hover:bg-neutral-10'
    style={{
      boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
    }}
    onClick={onClickMoreAction}
  >
    <img src={DocumentDownloadIcon} alt='Download' className='w-20 h-20' />
    <img
      src={ChevronDownIcon}
      alt=''
      className='w-16 h-16 transition-transform duration-300'
      style={{
        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      }}
    />
  </button>
);
